import { render, staticRenderFns } from "./consulting_services.vue?vue&type=template&id=2d735a2a&scoped=true"
import script from "./consulting_services.vue?vue&type=script&lang=js"
export * from "./consulting_services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d735a2a",
  null
  
)

export default component.exports